/**
 * 包裹查询覆盖范围的天数（PRD 包裹查询拆分：妥投后 N 天）。
 *
 * 与归档任务读同一个配置 common_config `order.archive.days`，解析口径与 `OrderArchiveScheduler`（api-server，
 * `getNumberConfigOrDefault`）一致：只看 configValue，**不看 isActive**；未配置 / 非 NUMBER 类型 / 值无法转数字 → 180，
 * 小于 15 按 15。页面上的「N 天」必须和真实归档天数一致，否则会出现「包裹查询选不到、历史也查不到」的空档。
 */
export const ORDER_ARCHIVE_DAYS_CONFIG_KEY = 'order.archive.days';
export const DEFAULT_ARCHIVE_DAYS = 180;
export const MIN_ARCHIVE_DAYS = 15;

export interface ArchiveDaysConfigLike {
    configValue?: string | null;
    configType?: string | null;
}

export function parseArchiveDays(config: ArchiveDaysConfigLike | null | undefined): number {
    if (!config || (config.configType && config.configType.toUpperCase() !== 'NUMBER')) {
        return DEFAULT_ARCHIVE_DAYS;
    }
    const value = Number((config.configValue ?? '').trim());
    if (!(config.configValue ?? '').trim() || !Number.isFinite(value)) {
        return DEFAULT_ARCHIVE_DAYS;
    }
    return Math.max(Math.trunc(value), MIN_ARCHIVE_DAYS);
}
